import { createNamespacedHelpers } from 'vuex';

const { mapGetters, mapState } = createNamespacedHelpers('bmr');

export const TypeParamMixin = {
    computed: {
        ...mapState(['availableLanguages']),
        ...mapGetters(['allPages']),
    },
    methods: {
        getPageTypeInfo (pageType) {
            if (pageType === 'upcoming-price-changes') {
                return this.allPages.find(p => p.route_name === 'PriceChangeList');
            }
            
            let pageInfo = this.allPages.find(p => {
                for (let language of this.availableLanguages) {
                    if (p[`slug_${language}`] === pageType || (p.route_params && p.route_params[`type_${language}`] === pageType)) {
                        return true;
                    }
                }
                return false;
            });
            return pageInfo;
        },
    }
};


// WEBPACK FOOTER //
// ./src/mixins/TypeParamMixin.js